export default {
    login: "Login",
    logout: "Wyloguj",
    home: "Dom",
    user: {
        profile: {
            edit: "Edytuj profil"
        }
    },
    approvals: {
        approvals: "Zatwierdzenia",
        delegates: "Delegaci"
    },
    impersonation: "Zamówienie w imieniu"
}